"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SegmentCreate = SegmentCreate;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("@heroui/react");
var react_2 = require("@iconify/react");
var react_3 = require("react");
var react_dom_1 = require("react-dom");
var react_redux_1 = require("react-redux");
var react_router_dom_1 = require("react-router-dom");
var letsachieve_1 = require("../../../../../api/letsachieve");
var read_only_banner_1 = require("../../../../../components/readOnlyBanner/read_only_banner");
var sectionHeader_1 = require("../../../../../components/sectionHeader");
var routes_1 = require("../../../../../constants/routes");
var permissions_1 = require("../../../../../hooks/permissions");
var IUser_1 = require("../../../../../interfaces/IUser");
var main_1 = require("../../../../../reducers/slices/main");
var constants_1 = require("../constants");
var rules_1 = require("../rules");
var segment_build_mode_field_1 = require("./segment_build_mode_field");
var segment_rules_builder_1 = require("./segment_rules_builder");
var segment_settings_1 = require("./segment_settings");
function SegmentCreate(_a) {
    var _this = this;
    var actions_container = _a.actions_container;
    var dispatch = (0, react_redux_1.useDispatch)();
    var navigate = (0, react_router_dom_1.useNavigate)();
    var canCreate = (0, permissions_1.usePermission)(IUser_1.IPermissions.SEGMENTS).canCreate;
    var _b = (0, letsachieve_1.useGetSegmentFieldsQuery)(), _c = _b.data, fields = _c === void 0 ? [] : _c, isLoadingFields = _b.isLoading;
    var _d = (0, letsachieve_1.useCreateSegmentMutation)(), createSegment = _d[0], isCreating = _d[1].isLoading;
    var _e = (0, react_3.useState)({ name: "", description: "", publish: false }), details = _e[0], setDetails = _e[1];
    var _f = (0, react_3.useState)([]), groups = _f[0], setGroups = _f[1];
    var _g = (0, react_3.useState)("run_actions"), buildMode = _g[0], setBuildMode = _g[1];
    var _h = (0, react_3.useState)(), nameError = _h[0], setNameError = _h[1];
    var _j = (0, react_3.useState)({}), ruleErrors = _j[0], setRuleErrors = _j[1];
    var handleDetailsChange = function (field, value) {
        setDetails(function (previous) {
            var _a;
            return (__assign(__assign({}, previous), (_a = {}, _a[field] = value, _a)));
        });
        if (field === "name")
            setNameError(undefined);
    };
    var handleRulesChange = function (next) {
        setGroups(next);
        setRuleErrors({});
    };
    var handleCreate = function () { return __awaiter(_this, void 0, void 0, function () {
        var nextRuleErrors, nextNameError, created, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    nextRuleErrors = (0, rules_1.validateGroupDrafts)(groups, fields);
                    nextNameError = details.name.trim() ? undefined : "Name is required";
                    setRuleErrors(nextRuleErrors);
                    setNameError(nextNameError);
                    if (nextNameError || Object.keys(nextRuleErrors).length > 0)
                        return [2 /*return*/];
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, createSegment({
                            name: details.name.trim(),
                            description: details.description.trim(),
                            rules: (0, rules_1.toSegmentRules)(groups, fields),
                            publish: details.publish,
                            build_mode: buildMode,
                        }).unwrap()];
                case 2:
                    created = _a.sent();
                    navigate((created === null || created === void 0 ? void 0 : created.id) ? "".concat(routes_1.CONSOLE_ROUTE).concat(routes_1.SEGMENTS_ROUTE, "/").concat(created.id) : "".concat(routes_1.CONSOLE_ROUTE).concat(routes_1.SEGMENTS_ROUTE));
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _a.sent();
                    dispatch((0, main_1.setMessageModal)({ title: "Something went wrong when creating your segment!", messages: [(0, constants_1.segmentErrorMessage)(error_1)] }));
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var saveButton = canCreate && actions_container
        ? (0, react_dom_1.createPortal)((0, jsx_runtime_1.jsxs)(react_1.Button, { size: "md", variant: "primary", isPending: isCreating, isDisabled: isLoadingFields, onPress: handleCreate, children: [(0, jsx_runtime_1.jsx)(react_2.Icon, { icon: "mdi:content-save", width: 24 }), "Save"] }), actions_container)
        : null;
    if (isLoadingFields) {
        return ((0, jsx_runtime_1.jsxs)("div", { className: "flex flex-col gap-4", children: [saveButton, (0, jsx_runtime_1.jsx)(react_1.Spinner, { size: "lg" })] }));
    }
    return ((0, jsx_runtime_1.jsxs)("div", { className: "flex flex-col gap-4", children: [saveButton, !canCreate && (0, jsx_runtime_1.jsx)(read_only_banner_1.ReadOnlyBanner, { feature: "segments", className: "w-full" }), (0, jsx_runtime_1.jsxs)("div", { className: "grid grid-cols-1 gap-6 md:grid-cols-2", children: [(0, jsx_runtime_1.jsxs)("div", { className: "flex flex-col gap-4", children: [(0, jsx_runtime_1.jsx)(sectionHeader_1.SectionHeader, { children: "Basic Information" }), (0, jsx_runtime_1.jsx)(segment_settings_1.SegmentDetailsFields, { form_data: details, on_change: handleDetailsChange, name_error: nameError, is_read_only: !canCreate })] }), (0, jsx_runtime_1.jsxs)("div", { className: "flex flex-col gap-4", children: [(0, jsx_runtime_1.jsx)(sectionHeader_1.SectionHeader, { children: "First Build" }), (0, jsx_runtime_1.jsx)(segment_build_mode_field_1.SegmentBuildModeField, { value: buildMode, on_change: setBuildMode, label: "Players who match when the segment is created", is_disabled: !canCreate })] })] }), (0, jsx_runtime_1.jsxs)("div", { className: "flex flex-col gap-4", children: [(0, jsx_runtime_1.jsx)(sectionHeader_1.SectionHeader, { children: "Rules" }), (0, jsx_runtime_1.jsx)(segment_rules_builder_1.SegmentRulesBuilder, { groups: groups, fields: fields, errors: ruleErrors, on_change: handleRulesChange, is_read_only: !canCreate })] })] }));
}
